import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const TESTIMONIAL_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/0b300931-695a-49f0-9c5f-246c460e28f3.jpg';
const badges = [{
  value: '-9 kg',
  label: 'en 3 meses'
}, {
  value: '10 km',
  label: 'sin parar'
}, {
  value: '8 meses',
  label: 'de hábito'
}];
export function FeaturedStory() {
  return <section className="w-full bg-ink" data-id="element-42" data-mp="g8h4j7pnnvhz">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-24" data-id="element-43" data-mp="g9ie17r0w9xl">
        <Reveal className="text-center" data-id="element-44" data-mp="l8btv6ts8d0x">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-sm font-semibold text-amber-300" data-id="element-45" data-mp="l7ag2uldtcfi">
            <StarIcon className="h-4 w-4 fill-amber-300" data-id="element-46" data-mp="c759gmo0ii2e" /> Historia real de transformación
          </span>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 items-center gap-10 lg:grid-cols-[0.8fr_1.2fr]" data-id="element-47" data-mp="2ry9w9njmaqhq">
          <Reveal data-id="element-48" data-mp="2wxwb21f3gesn">
            <div className="overflow-hidden rounded-[2rem] shadow-2xl ring-1 ring-white/10" data-id="element-49" data-mp="2wye2mkqta4u8">
              <img src={TESTIMONIAL_IMG} alt="Valeria Méndez, alumna estrella del programa" className="h-full w-full object-cover" data-id="element-50" data-mp="2ytst19pe751g" />
            </div>
          </Reveal>

          <Reveal delay={0.1} data-id="element-51" data-mp="38ouenvkgloza">
            <div data-id="element-52" data-mp="33s3yl88nmtdv">
              <h3 className="font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-53" data-mp="33rkrynogfrf5">
                Valeria Méndez — Alumna estrella
              </h3>
              <p className="mt-2 text-sm font-medium text-white/60" data-id="element-54" data-mp="3hpiwl1cz49hg">
                Córdoba, Argentina · -9 kg en 3 meses · Hábito de por vida
              </p>

              <blockquote className="mt-6 border-l-4 border-brand pl-5 text-lg italic leading-relaxed text-white/85" data-id="element-55" data-mp="3rg3qibhpcpu1">
                "Entré al programa con mucho miedo y poca fe. Llevaba años intentando bajar de peso
                y siempre abandonaba. Pero acá fue diferente: los 6 módulos me dieron el
                conocimiento que nunca nadie me había explicado. Entendí por qué no funcionaban las
                dietas que hacía, aprendí a caminar de verdad y armé una rutina que pude sostener en
                el tiempo. En 3 meses bajé 9 kilos y hoy camino todos los días porque me encanta, no
                porque tengo que hacerlo."
              </blockquote>

              <p className="mt-6 text-sm leading-relaxed text-white/60" data-id="element-56" data-mp="m3gcewbs9bc6">
                Valeria es mamá de tres hijos, trabaja en dos empleos y nunca había hecho actividad
                física de forma constante. Hoy es nuestra alumna más destacada y la prueba viva de
                que el método funciona para cualquier persona, sin importar su punto de partida.
              </p>

              <div className="mt-8 grid grid-cols-3 gap-4" data-id="element-57" data-mp="152lzc302maze">
                {badges.map(b => <div key={b.label} className="rounded-xl bg-white/5 p-4 text-center ring-1 ring-white/10" data-id="element-58" data-mp="31uvu4t77bmgm">
                    <p className="font-display text-xl font-bold text-brand" data-id="element-59" data-mp="36snodtvbjknz">{b.value}</p>
                    <p className="mt-1 text-xs text-white/60" data-id="element-60" data-mp="1nyum4x3d8j31">{b.label}</p>
                  </div>)}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}